import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { WritableComputedRef, computed, useAttrs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldText',
  props: {
  modelValue: {
    type: String,
  },
},
  emits: {
  'update:modelValue': null,
},
  setup(__props, { emit }) {

const props = __props;





const attrs = useAttrs();

const fieldValue: WritableComputedRef<string | undefined> = computed({
  get(): string | undefined {
    return props.modelValue;
  },
  set(value: string | undefined): void {
    emit('update:modelValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldValue) ? (fieldValue).value = $event : null))
    }, _unref(attrs), { type: "text" }), null, 16), [
      [_vModelText, _unref(fieldValue)]
    ])
  ]))
}
}

})